<template>
  <div id="app">
    <DevRoleSwitcher />
    <router-view></router-view>
  </div>
</template>

<script>
import DevRoleSwitcher from '@/components/common/DevRoleSwitcher';

export default {
  name: 'App',
  components: {
    DevRoleSwitcher
  },
  created() {
    this.$store.dispatch("auth/supportReload");
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
